import React from 'react'

export type CopyrightNoticeProps = {
  companyName?: string
}

export const CopyrightNotice = ({ companyName }: CopyrightNoticeProps) => {
  const currentYear = new Date().getFullYear()
  companyName = companyName || 'PCMLI'
  return (
    <div>
      <strong>Copyright</strong> {companyName} &copy; {currentYear}
    </div>
  )
}
